import simbApi from ".";
import { GET_BOARD_WEBHOOKS, REINSTALL_SELECTED_WEBHOOKS } from "../../data/constants/endpoints";
import logger from "../../lib/logger";

interface WebhookPayload {
  id?: string;
  event: string;
}

export interface WebhookResult {
  event: string;
  status: "success" | "error";
  error?: string;
}

interface BoardWebhooksData {
  installed: Array<{ id: string; event: string; board_id: number; config: string }>;
  uninstalled: Array<{ event: string }>;
}

export const getBoardWebhooks = async (boardId: number): Promise<BoardWebhooksData> => {
  try {
    const response = await simbApi.post(GET_BOARD_WEBHOOKS, { boardId });

    if (response?.data?.error) {
      throw new Error(response.data.message || response.data.error);
    }

    return response.data.data;
  } catch (error: any) {
    logger.error("Failed to get board webhooks", error);
    throw error;
  }
};

export const reinstallSelectedWebhooks = async (
  boardId: number,
  webhooks: WebhookPayload[],
): Promise<WebhookResult[]> => {
  try {
    const response = await simbApi.post(REINSTALL_SELECTED_WEBHOOKS, {
      boardId,
      webhooks,
    });

    if (response?.data?.error) {
      throw new Error(response.data.message || response.data.error);
    }

    return response.data.data.results;
  } catch (error: any) {
    logger.error("Failed to reinstall selected webhooks", error);
    throw error;
  }
};
